import './public-path';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
//import reportWebVitals from './reportWebVitals';
import zhCN from 'antd/lib/locale/zh_CN';
import '@formily/antd/dist/antd.css';
import 'antd/dist/antd.css';
import './index.css';
import '@designable/react-settings-form/dist/designable.settings-form.umd.production.css'
import '@designable/react/dist/designable.react.umd.production.css'

import Token from './request/token'

function render(props) {
  const { container } = props;
  ReactDOM.render(<App {...props}/>, container ? container.querySelector('#rootReact') : document.querySelector('#rootReact'));
}
// 如果是单独运行项目，则直接渲染
if (!window.__POWERED_BY_QIANKUN__) {
  render({});
}
/* ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
); */

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();

/**
 * bootstrap 只会在微应用初始化的时候调用一次，下次微应用重新进入时会直接调用 mount 钩子，不会再重复触发 bootstrap。
 * 通常我们可以在这里做一些全局变量的初始化，比如不会在 unmount 阶段被销毁的应用级别的缓存等。
 */
export async function bootstrap() {
  if(window.token && Token){
    let obj = JSON.parse(window.token);
    Token.set(obj.value)
  }
  console.log('react app bootstraped');
}
/**
 * 应用每次进入都会调用 mount 方法，通常我们在这里触发应用的渲染方法
 */
export async function mount(props) {
  if(window.token){
    let obj = JSON.parse(window.token);
    Token.set(obj.value)
  }
  props.onGlobalStateChange((cur, prev) => {
    //console.log(`[onGlobalStateChange - react]:`, cur, prev)
    if(cur && cur.token){
      Token.set(cur.token)
    }
  }, true);
  render(props);
}
/**
 * 应用每次 切出/卸载 会调用的方法，通常在这里我们会卸载微应用的应用实例
 */
export async function unmount(props) {
  const { container } = props;
  ReactDOM.unmountComponentAtNode(container ? container.querySelector('#rootReact') : document.querySelector('#rootReact'));
}
/**
 * 可选生命周期钩子，仅使用 loadMicroApp 方式加载微应用时生效
 */
export async function update(props) {
  console.log('update props', props);
}